export default "__VITE_ASSET__bd1490fd__"